export const toCurrency = (val: number): string => {
  // Fallback to avoid rendering $NaN
  if (isNaN(val)) {
    return ``;
  }

  return val.toLocaleString(`en-US`, {currency: `USD`, style: `currency`});
};

export function formatDate(date: Date): string {
  return date.toLocaleDateString(`en-US`, {day: `2-digit`, month: `short`, year: `numeric`});
}
